import React, { FC, Suspense } from 'react';
import { Route, Routes as ReactRoutes } from 'react-router-dom';
import { DebouncedLineLoader } from '@layout/loaders/line-loader/LineLoader';
import FullError from '@modules/error/components/FullError';
import { HttpError } from '@core/http';

export const Routes: FC = ({ children }) => (
  <Suspense fallback={<DebouncedLineLoader />}>
    <ReactRoutes>
      {children}
      <Route path="*" element={<FullError error={HttpError.notFound} />} />
    </ReactRoutes>
  </Suspense>
);
